import Log from '../Utility/Log';
import Vue from 'vue';

export default {
	/**
	 * Install Components
	 */
	install: (app: any, options: any) => {
		// Log
		Log.info('app', 'Initializing app with', options);

		// Directives (like v-model, v-show)
		// @see https://vuejs.org/v2/guide/custom-directive.html

		// Provide components
		const requireComponent = require.context(
			'../App',
			true,
			/^\.\/(.+\/)*(Element|Layout|Page|View)(\/[A-Z]\w+)+\.(vue|js)$/,
		);

		// For each matching component filename...
		requireComponent.keys().forEach((filename: string) => {
			// Get the component config
			const componentConfig = requireComponent(filename);

			// Get the PascalCase version of the component name
			const componentName = filename
				.replace('.vue', '')
				.replace(/[^a-zA-Z0-9-]+/g, '')
				.replace(/(index)$/i, '');

			// Register the component globally
			app.component(componentName, componentConfig.default || componentConfig);
		});
	},
};
